import styled from 'styled-components';

export const AppContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  width: 100%;
  background-color: rgba(8, 9, 12, 1);

  video::-webkit-media-controls {
    display: none !important;
  }

  video::-webkit-media-controls-start-playback-button {
    display: none !important;
  }
`;

export const Container = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  z-index: 1000;
  background-color: #000;
  overflow: hidden;
`;

export const IOSContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  background-color: #000;
  overflow: hidden;

  video::-webkit-media-controls {
    display: none !important;
  }

  video::-webkit-media-controls-enclosure {
    display: none !important;
  }

  video {
    -webkit-appearance: none;
  }
`;

export const VideoBackground = styled.video`
  position: absolute;
  width: 100%;
  height: 100%;
  object-fit: contain;
  z-index: 1;
  pointer-events: none !important;

  /* Visually hide native controls */
  &::-webkit-media-controls {
    opacity: 0 !important;
    pointer-events: none !important;
    position: absolute !important;
    z-index: -1 !important;
  }

  &::-webkit-media-controls-panel {
    display: none !important;
    opacity: 0 !important;
    pointer-events: none !important;
    position: absolute !important;
    z-index: -1 !important;
  }
`;

export const TouchOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 5;
  pointer-events: none !important;
`;

export const Overlay = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  z-index: 10;
  display: flex;
  flex-direction: column;
  padding: 16px;
  box-sizing: border-box;
  background: linear-gradient(
    to bottom,
    rgba(0, 0, 0, 0.5) 0%,
    rgba(0, 0, 0, 0.2) 30%,
    rgba(0, 0, 0, 0.2) 70%,
    rgba(0, 0, 0, 0.5) 100%
  );
  pointer-events: none;
`;

export const ProgressContainer = styled.div`
  display: flex;
  justify-content: center;
  gap: 4px;
  width: 100%;
  margin-bottom: 12px;
  pointer-events: none;
`;

export const ProgressTile = styled.div`
  height: 2px;
  flex: 1;
  background-color: rgba(255, 255, 255, 0.4);
  border-radius: 3px;
  overflow: hidden;
`;

export const ProgressFill = styled.div`
  height: 100%;
  background-color: rgba(255, 255, 255, 1);
  border-radius: 3px;
`;

export const CloseButton = styled.button`
  position: absolute;
  top: 32px;
  right: 16px;
  background-color: rgba(41, 41, 41, 0.8);
  border: transparent;
  border-radius: 50%;
  cursor: pointer;
  z-index: 10;
  max-height: 32px;
  max-width: 32px;
  height: 32px;
  width: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: auto;
`;

export const NavigationButton = styled.button<{
  position: 'left' | 'right';
  disabled?: boolean;
}>`
  position: absolute;
  top: 50%;
  ${(props) => (props.position === 'left' ? 'left: 16px;' : 'right: 16px;')}
  transform: translateY(-50%);
  background-color: rgba(0, 0, 0, 0.3);
  border: none;
  border-radius: 50%;
  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  cursor: pointer;
  pointer-events: auto;
  opacity: ${(props) => (props.disabled ? 0.5 : 0.7)};
  transition: opacity 0.2s ease;

  &:hover {
    opacity: ${(props) => (props.disabled ? 0.5 : 1)};
  }

  &:disabled {
    cursor: default;
  }
`;

export const LoadingIndicator = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 40px;
  height: 40px;
  border: 4px solid rgba(255, 255, 255, 0.3);
  border-radius: 50%;
  border-top-color: white;
  animation: spin 1s linear infinite;

  @keyframes spin {
    to {
      transform: translate(-50%, -50%) rotate(360deg);
    }
  }
`;

export const StartWritingButton = styled.button`
  position: fixed;
  bottom: 4px;
  background-color: rgba(229, 26, 77, 1);
  color: rgba(253, 253, 253, 1);
  border: none;
  border-radius: 8px;
  padding: 16px;
  font-size: 14px;
  line-height: 20px;
  font-family: Noto Sans;
  font-weight: 700;
  cursor: pointer;
  align-self: center;
  pointer-events: auto;
  width: calc(100vw - 48px);
  margin: 16px auto;
`;

export const AudioButton = styled.button`
  position: absolute;
  top: 32px;
  left: 16px;
  background-color: rgba(41, 41, 41, 0.8);
  border: transparent;
  border-radius: 50%;
  cursor: pointer;
  z-index: 10;
  max-height: 32px;
  max-width: 32px;
  height: 32px;
  width: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const PlayerWrapper = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 1;

  .react-player {
    width: 100% !important;
    height: 100% !important;
  }

  video {
    object-fit: contain !important;
  }
`;

export const PlayButton = styled.button`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: rgba(49, 49, 49, 0.93);
  border: 1px solid rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(1px);
  box-shadow: 0px 2px 24px 0px rgba(0, 0, 0, 0.46);
  border-radius: 50%;
  cursor: pointer;
  z-index: 100;
  height: 100px;
  width: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: auto;
  transition: transform 0.2s ease;
`;
